import styled from "styled-components";
import { spacing } from "@styling/sizing";

const ListContainer = styled.div<{ $dense?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ $dense }) => ($dense ? spacing.x1 : spacing.x2)}px;
`;

type ListProps = {
  children: React.ReactNode;
  dense?: boolean;
};

export const List = ({ children, dense }: ListProps) => {
  return <ListContainer $dense={dense}>{children}</ListContainer>;
};

